import styled from 'styled-components'

import { LinkButton } from '@sketch/components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  /* Override IndexLayout SubTitle styles */
  && {
    margin: 24px auto 32px auto;

    /* Override Button sibling styles */
    button + button,
    button + a,
    a + a {
      margin-left: 0px;
    }
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
`

export const StyledLinkButton = styled(LinkButton)`
  flex: 1;
`

export const Divider = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
  font-size: ${({ theme }) => theme.fontSizes.E};
  text-align: center;
  margin-top: 8px;
  opacity: 0.4;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.border.A};
  }

  &::before {
    margin-right: 8px;
    margin-left: 12px;
  }

  &::after {
    margin-left: 8px;
    margin-right: 12px;
  }
`
